import { defineStore } from "pinia";
// import type { CustomTableColumn } from "@/types";
import type { UserItem } from "@/types/system/user";
import cache from "@/utils/cache";
import { COLUMN, ACCOUNT, TOKEN, RESETCACHE, TABS } from "@/global/constant";
import { getUserInfo } from "@/api/common";
import { GA_MEASUREMENT_ID } from "@/plugins/gtag";
import type { CustomTableColumn } from "@/types";
import cacheVersion from "@/config/cacheVersion.json";

export interface ListColumn {
  offer: CustomTableColumn[];
  advertiser: CustomTableColumn[];
  affiliate: CustomTableColumn[];
  tradeList: CustomTableColumn[];
  tradeApprove: CustomTableColumn[];
  proxyTradeApprove: CustomTableColumn[];
  tradeCapAdjust: CustomTableColumn[];
  tradeH5Manage: CustomTableColumn[];
  budgetProcess_offer: CustomTableColumn[];
  budgetProgress_aff: CustomTableColumn[];
  budgetProgress_adv: CustomTableColumn[];
  blockList: CustomTableColumn[];
  roiPanelList: CustomTableColumn[];
  treeColumnsOfroiPanelList: CustomTableColumn[];
}
const useAccount = defineStore("account", {
  state: () => {
    return {
      backRoutePath: "",
      userInfo: {} as UserItem,
      token: "",
      productEnv: "https://pac-bop.tec-do.com",
      testEnv: "https://test01-bop-front.tec-develop.cn",
      oldProductEnv: "https://portal.tec-do.com",
      oldTestEnv: "http://172.24.2.38:8888",
      listColumn: {
        offer: [],
        advertiser: [],
        affiliate: [],
        tradeList: [],
        tradeApprove: [],
        tradeCapAdjust: [],
        tradeH5Manage: [],
        budgetProgress_adv: [],
        budgetProcess_offer: [],
        budgetProgress_aff: [],
        proxyTradeApprove: [],
        blockList: [],
        roiPanelList: [],
        treeColumnsOfroiPanelList: []
      } as ListColumn
    };
  },
  getters: {
    isProduct(): boolean {
      return window.location.hostname === "pac-bop.tec-do.com";
    },
    oldSystemLink(): string {
      return this.isProduct ? this.oldProductEnv : this.oldTestEnv;
    },
    isToRole(): boolean {
      return this.currentRoleName?.includes("pac-to");
    },
    isCmRole(): boolean {
      return this.currentRoleName?.includes("pac-cm");
    },
    isBdRole(): boolean {
      return this.currentRoleName?.includes("pac-bd");
    },
    isFinanceRole(): boolean {
      return this.currentRoleName?.includes("pac-financial-bp");
    },
    isAdminRole(): boolean {
      return this.currentRoleName?.includes("admin");
    },
    parentUserId(): string {
      return (
        this.userInfo.parentId.toString() ||
        cache.getCache(ACCOUNT)?.parentId.toString()
      );
    },
    currentRoleName(): string {
      return this.userInfo.roleName || cache.getCache(ACCOUNT)?.roleName;
    },
    currentUserId(): string {
      return this.userInfo.id || cache.getCache(ACCOUNT)?.id;
    }
  },
  actions: {
    setBackRoutePath(path: string) {
      this.backRoutePath = path;
    },
    setToken(token: string) {
      this.token = token;
      cache.setCache(TOKEN, token);
    },
    setUserInfo(info: UserItem) {
      this.userInfo = info;
      cache.setCache(ACCOUNT, info);
    },
    setListColumn(key: keyof ListColumn, value: CustomTableColumn[]) {
      this.listColumn = { ...this.listColumn, [key]: value };
      cache.setCache(COLUMN, this.listColumn);
    },
    initListColumn() {
      this.resetCacheKey(COLUMN);
      this.resetCacheKey(TABS);
      const cacheColumn = cache.getCache(COLUMN);
      if (!cacheColumn) {
        cache.setCache(COLUMN, this.listColumn);
      } else {
        this.listColumn = cacheColumn;
      }
    },
    resetCacheKey(key: string) {
      const resetFlag = cache.getCache(RESETCACHE);
      const defaultFlag = cacheVersion.version;
      if (resetFlag === defaultFlag) {
        return;
      } else {
        cache.deleteCache(key);
        cache.setCache(RESETCACHE, defaultFlag);
      }
    },
    initUserInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          this.setUserInfo(res.data);
          window.gtag("config", GA_MEASUREMENT_ID, {
            user_id: res.data.id,
            user_name: res.data.account
          });
        }
      });
    }
  }
});

export default useAccount;
